import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';

import { DividerComponent } from '../../divider/divider.component';
import { IconColorDirective } from '../../icon/directives/icon-color.directive';
import { IconComponent } from '../../icon/icon.component';

/**
 * @description In html mark left item (e.g. icon) as __'prefix'__ to render it in left spot.
 * @description Mark right item as __'suffix'__.
 * @description Use __.info-dropdown-text__ class (from /styles/misc) on nested _div_ for 'subheading' text in read only item.
 *
 *
 *  __> INPUTS:__
 *  - __href__: _boolean_ | _string_ - address for navigation if element act as link or _false_ when not.
 *  - __hrefTarget__: _string_ - href target provided as a string.
 *
 *  - __highlighted__: _boolean_ - render element with onHover style.
 *  - __hasHoverEffect__: _boolean_ - disable hover color and pointer cursor.
 *  - __isCreateAction__: _boolean_ - apply 'primary' color styling and hover state.
 *  - __noDivider__: _boolean_ - disable render of divider under element
 *
 *  predefined __suffix__ elements
 * - __isSelected__: _boolean_ - render green check icon on right side.
 * - __hasChevronRight__: _boolean_ - render chevron right icon on right side.
 *
 */

@Component({
  selector: 'rt-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.highlighted]': 'highlighted',
    '[class.create-action]': 'isCreateAction',
    '[class.no-hover-effect]': '!hasHoverEffect',
    '[class]': 'highlightColor + "-highlighted"',
  },
  standalone: true,
  imports: [NgIf, IconColorDirective, IconComponent, DividerComponent],
})
export class DropdownItemComponent {
  // optional link properties (if element act as link)
  @Input() public href: boolean | string = false;
  @Input() public hrefTarget: string | null;

  @Input() public highlighted: boolean; // change background as in hover state
  @Input() public highlightColor: 'default' | 'blue' | 'disabled' = 'default';
  @Input() public hasHoverEffect: boolean = true; // disable all hover effects on item (background, cursor)
  @Input() public isCreateAction: boolean = false; // apply 'primary' color styling and hover state
  @Input() public noDivider: boolean = false;

  // predefined suffix elements
  @Input() public isSelected: boolean; // render green check next to suffix (left)
  @Input() public hasChevronRight: boolean = false; // render chevron right icon next to suffix (left)

  constructor(public elRef: ElementRef) {}
}
